<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '~/stores/auth';
import { isNilOrEmpty } from '~/utils';

const props = defineProps({
  compromisso: {
    default: null,
    type: Object,
  },
});

const emit = defineEmits(['close', 'loaded', 'success', 'error']);

const authStore = useAuthStore();

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <div>
    <CompromissoJobCommandForm
      command="EnviarEmailConfirmacaoAjuizamentoAgenciaCommand"
      :show-upload-files="true"
      :submit-button-disabled="!isNilOrEmpty(compromisso)
        && compromisso.responsavel.codigo !== authStore.codigoUsuario"
      :initial-model="{
        compromissoCodigos: props.compromisso ? [props.compromisso.codigo] : null,
      }"
      @close="() => emit('close')"
    >
      <template #form>
        <a-alert type="warning">
          <template #message>
            Caso você tenha enviado o email de confirmação de ajuizamento à
            agência, finalize o compromisso
          </template>
        </a-alert>
      </template>
    </Compromissojobcommandform>
  </div>
</template>
